module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_8023.76042613.png";